"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link SuppliedProductOverviewFilter}.
 * @author Radek Beran
 */


var SuppliedProductOverviewFilterConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SuppliedProductOverviewFilterConverter, _DataObjectConverter_);

  function SuppliedProductOverviewFilterConverter() {
    _classCallCheck(this, SuppliedProductOverviewFilterConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProductOverviewFilterConverter).apply(this, arguments));
  }

  return SuppliedProductOverviewFilterConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SuppliedProductOverviewFilterConverter = SuppliedProductOverviewFilterConverter;